/**
 * The address of a listing on REALTOR.ca, made safe to use as a link (CREA rule 6(a)(i)).
 * No imports, so it can be tested with `node --test`.
 */

const HOSTS = ["www.realtor.ca", "realtor.ca"];

/**
 * CREA's `ListingURL` often arrives without a scheme (`www.realtor.ca/real-estate/...`), which a
 * browser would read as a path on our own site. This adds `https://` when there is no scheme
 * and returns the address only if it is an https address on realtor.ca (or www.realtor.ca);
 * anything else, including other hosts, other schemes, embedded credentials and ports, gives
 * null (no link). The stored value is never changed.
 */
export function realtorListingHref(raw: string | null | undefined): string | null {
    const value = raw?.trim();
    if (!value) return null;
    let candidate = value;
    if (value.startsWith("//")) candidate = `https:${value}`;
    else if (!/^[a-z][a-z0-9+.-]*:/i.test(value) || /^[^/?#:]+:\d+(\/|$)/.test(value)) candidate = `https://${value}`;
    try {
        const url = new URL(candidate);
        if (url.protocol !== "https:" || url.username || url.password || url.port) return null;
        return HOSTS.includes(url.hostname.toLowerCase()) ? url.toString() : null;
    } catch {
        return null;
    }
}
